import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { DEFAULT_URI } from '@/constants';

const state = {
  businessProcesses: [],
  selectedBusinessProcesses: [DEFAULT_URI],
  customizedBusinessProcesses: []
};

export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
};
